import React from 'react'
import { connect } from 'react-redux'
import ContactInfo from '../ContactInfo/'
// import Tasks from '../Tasks'
// import StartAConversation from '../StartAConversation'
import Groups from '../Groups/'
import CustomAttributes from '../CustomAttributes'
import Activities from '../Activities'

export default connect(
	(state) => ({ bottomNavigation: state.contacts.bottomNav }),
	null,
)(({ bottomNavigation, inbox }) => {
	switch (bottomNavigation) {
		case 0:
			return (
				<div
					style={{
						backgroundColor: '#fff',
						padding: '8px 20px',
						borderRadius: 20,
						border: '1px solid #e5e5e5',
						// boxShadow:
						// 	'0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)',
					}}
				>
					<ContactInfo inbox={inbox} />
				</div>
			)
		// case 1:
		// 	return (
		// 		<div
		// 			style={{
		// 				backgroundColor: '#fff',
		// 				padding: '8px 20px',
		// 				borderRadius: 20,
		// 				border: '1px solid #e5e5e5',
		// 				boxShadow:
		// 					'0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)',
		// 			}}
		// 		>
		// 			<StartAConversation />
		// 		</div>
		// 	)
		case 1:
			return (
				<div
					style={{
						backgroundColor: '#fff',
						padding: '8px 20px',
						borderRadius: 20,
						border: '1px solid #e5e5e5',
						// boxShadow:
						// 	'0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)',
					}}
				>
					<Groups />
				</div>
			)
		case 2:
			return (
				<div
					style={{
						backgroundColor: '#fff',
						padding: '8px 20px',
						borderRadius: 20,
						border: '1px solid #e5e5e5',
						// boxShadow:
						// 	'0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)',
					}}
				>
					<CustomAttributes />
				</div>
			)
		case 3:
			return <Activities mobile inbox={inbox} />
		default:
			return (
				<div
					style={{
						backgroundColor: '#fff',
						padding: '8px 20px',
						borderRadius: 20,
						border: '1px solid #e5e5e5',
						// boxShadow:
						// 	'0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)',
					}}
				>
					<ContactInfo />
				</div>
			)
	}
})
